import { render, staticRenderFns } from "./OfferQuestionForm.vue?vue&type=template&id=34064df7&scoped=true&"
import script from "./OfferQuestionForm.vue?vue&type=script&lang=js&"
export * from "./OfferQuestionForm.vue?vue&type=script&lang=js&"
import style0 from "./OfferQuestionForm.vue?vue&type=style&index=0&id=34064df7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34064df7",
  null
  
)

export default component.exports